import React, { useEffect, useState } from "react"
import { Form, Label, Row, Col, Input, FormFeedback } from "reactstrap"
import toast from "react-hot-toast"
import { useFormik } from "formik"
import * as Yup from "yup"
import { useBusinessDetailsManuallyProfileMutation } from "store/api/profile/profile.api"
import Spinners from "components/Common/Spinner"
import { allStates } from "helpers/utils"
import CummunicationAddress from "pages/KYC/CummunicationAddress"
import { businessTypes, renderAddressValue } from "helpers/common"
import { useSelector } from "react-redux"

const CompanyDetails = ({ kycData }) => {
  const [manuallySave, { isLoading }] =
    useBusinessDetailsManuallyProfileMutation()
  const [openAddress, setOpenAddress] = useState(false)
  const { userType } = useSelector((state) => state.user)

  const proceedToNext = () => {
    window.location.reload()
  }

  const onSaveManually = async (params) => {
    try {
      const { success, message } = await manuallySave({
        ...params,
      }).unwrap()
      if (success) {
        toast.success(message, { id: "toastMessage" })
        proceedToNext()
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }

      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      entity_name: "",
      gstin: "",
      constitution_of_business: "",
      business_address: "",
      address_one: "",
      address_two: "",
      address_three: "",
      city: "",
      state: "",
      pin_code: "",
      is_comm_address_same: "SAME",
      communication_address: "",
    },
    validationSchema: Yup.object({}),
    onSubmit: async (values) => {
      onSaveManually(values)
    },
  })

  useEffect(() => {
    if (
      validation.values.is_comm_address_same === "DIFFERENT" &&
      !validation.values.communication_address
    ) {
      setOpenAddress(true)
    }
  }, [validation.values])

  useEffect(() => {
    let params = {
      entity_name: kycData?.investorCompanyDetails?.entity_name,
      gstin: kycData?.investorCompanyDetails?.gstin,
      gst_waiver: kycData?.investorCompanyDetails?.gst_waiver,
      business_address: kycData?.investorCompanyDetails?.business_address,
      is_comm_address_same:
        kycData?.investorCompanyDetails?.is_comm_address_same,
      communication_address:
        kycData?.investorCompanyDetails?.communication_address,
      constitution_of_business:
        kycData?.investorCompanyDetails?.constitution_of_business,
      addressType: "SINGLE",
    }

    if (!kycData?.investorCompanyDetails?.business_address) {
      params = {
        ...params,
        address_one: kycData?.investorCompanyDetails?.address_one,
        address_two: kycData?.investorCompanyDetails?.address_two,
        address_three: kycData?.investorCompanyDetails?.address_three,
        city: kycData?.investorCompanyDetails?.city,
        state: kycData?.investorCompanyDetails?.state,
        pin_code: kycData?.investorCompanyDetails?.pin_code,
        addressType: "MULTIPLE",
      }
    }

    validation.setValues(params)
  }, [kycData])

  return (
    <>
      <div className="bank-details-wrapper">
        <h5 className="title mb-3">
          {userType === "WEALTH_PARTNER"
            ? "Entity Details"
            : "Company Details"}{" "}
        </h5>
        <div>
          <Form
            onSubmit={(e) => {
              e.preventDefault()
              validation.handleSubmit()
              return false
            }}
          >
            <Row className="mb-2">
              <Col xl={12}>
                <Label className="col-form-label">
                  Name of the Entity<span className="error">*</span>
                </Label>
                <Input
                  name="entity_name"
                  type="text"
                  className="form-control"
                  id="horizontal-firstname-Input"
                  placeholder="XXXX"
                  value={validation.values.entity_name}
                  onChange={validation.handleChange}
                  invalid={
                    validation.touched.entity_name &&
                    validation.errors.entity_name
                  }
                />

                {validation.touched.entity_name &&
                validation.errors.entity_name ? (
                  <FormFeedback type="invalid">
                    {validation.errors.entity_name}
                  </FormFeedback>
                ) : null}
              </Col>

              {!kycData?.investorCompanyDetails?.gst_waiver && (
                <Col xl={12}>
                  <Label className="col-form-label">
                    GSTIN <span className="error">*</span>
                  </Label>
                  <Input
                    name="gstin"
                    type="text"
                    className="form-control"
                    id="horizontal-firstname-Input"
                    placeholder="XXXXXXXXX"
                    value={validation.values.gstin}
                    onChange={validation.handleChange}
                    invalid={
                      validation.touched.gstin && validation.errors.gstin
                    }
                  />

                  {validation.touched.gstin && validation.errors.gstin ? (
                    <FormFeedback type="invalid">
                      {validation.errors.gstin}
                    </FormFeedback>
                  ) : null}
                </Col>
              )}

              <Col xl={12}>
                <Label className="col-form-label">
                  Constitution of Business <span className="error">*</span>
                </Label>
                <select
                  id="constitution_of_business"
                  name="constitution_of_business"
                  className={`form-select pageSize ${
                    validation.touched.constitution_of_business &&
                    validation.errors.constitution_of_business &&
                    "is-invalid"
                  }`}
                  value={validation.values.constitution_of_business}
                  onChange={validation.handleChange}
                >
                  <option value={"item"}>Select</option>
                  {businessTypes(userType).map((item, index) => (
                    <option
                      key={`constitution_of_business_${index}`}
                      value={item}
                    >
                      {item}
                    </option>
                  ))}
                </select>
                {validation.touched.constitution_of_business &&
                validation.errors.constitution_of_business ? (
                  <FormFeedback type="invalid">
                    {validation.errors.constitution_of_business}
                  </FormFeedback>
                ) : null}
              </Col>

              {kycData?.investorCompanyDetails?.business_address && (
                <Col xl={12}>
                  <Label className="col-form-label">
                    Registered Address
                    <span className="error">*</span>
                  </Label>
                  <Input
                    name="business_address"
                    type="text"
                    className="form-control"
                    id="horizontal-firstname-Input"
                    placeholder="XXXX"
                    value={validation.values.business_address}
                    onChange={validation.handleChange}
                    invalid={
                      validation.touched.business_address &&
                      validation.errors.business_address
                    }
                  />

                  {validation.touched.business_address &&
                  validation.errors.business_address ? (
                    <FormFeedback type="invalid">
                      {validation.errors.business_address}
                    </FormFeedback>
                  ) : null}
                </Col>
              )}
              {!kycData?.investorCompanyDetails?.business_address && (
                <>
                  <Col xl={12}>
                    <Label className="col-form-label">
                      Registered Address Line 1<span className="error">*</span>
                    </Label>
                    <Input
                      name="address_one"
                      type="text"
                      className="form-control"
                      id="horizontal-firstname-Input"
                      placeholder="Registered Address Line 1"
                      value={validation.values.address_one}
                      onChange={validation.handleChange}
                      invalid={
                        validation.touched.address_one &&
                        validation.errors.address_one
                      }
                    />
                    {validation.touched.address_one &&
                    validation.errors.address_one ? (
                      <FormFeedback type="invalid">
                        {validation.errors.address_one}
                      </FormFeedback>
                    ) : null}
                  </Col>
                  <Col xl={12}>
                    <Label className="col-form-label">
                      Registered Address Line 2
                    </Label>
                    <Input
                      name="address_two"
                      type="text"
                      className="form-control"
                      id="horizontal-firstname-Input"
                      placeholder="Registered Address Line 2"
                      value={validation.values.address_two}
                      onChange={validation.handleChange}
                      invalid={
                        validation.touched.address_two &&
                        validation.errors.address_two
                      }
                    />
                    {validation.touched.address_two &&
                    validation.errors.address_two ? (
                      <FormFeedback type="invalid">
                        {validation.errors.address_two}
                      </FormFeedback>
                    ) : null}
                  </Col>
                  <Col xl={12}>
                    <Label className="col-form-label">
                      Registered Address Line 3
                    </Label>
                    <Input
                      name="address_three"
                      type="text"
                      className="form-control"
                      id="horizontal-firstname-Input"
                      placeholder="Registered Address Line 3"
                      value={validation.values.address_three}
                      onChange={validation.handleChange}
                      invalid={
                        validation.touched.address_three &&
                        validation.errors.address_three
                      }
                    />
                    {validation.touched.address_three &&
                    validation.errors.address_three ? (
                      <FormFeedback type="invalid">
                        {validation.errors.address_three}
                      </FormFeedback>
                    ) : null}
                  </Col>
                  <Col xl={12}>
                    <Label className="col-form-label">
                      City<span className="error">*</span>
                    </Label>
                    <Input
                      name="city"
                      type="text"
                      className="form-control"
                      id="horizontal-firstname-Input"
                      placeholder="Enter City"
                      value={validation.values.city}
                      onChange={validation.handleChange}
                      invalid={
                        validation.touched.city && validation.errors.city
                      }
                    />
                    {validation.touched.city && validation.errors.city ? (
                      <FormFeedback type="invalid">
                        {validation.errors.city}
                      </FormFeedback>
                    ) : null}
                  </Col>

                  <Col xl={12}>
                    <Label className="col-form-label">
                      State<span className="error">*</span>
                    </Label>

                    <select
                      id="state"
                      name="state"
                      className="form-select"
                      value={validation.values.state}
                      onChange={validation.handleChange}
                    >
                      <option value=""> Select</option>
                      {allStates.map((item, index) => (
                        <option key={`business_type_${index}`} value={item.key}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                    {validation.touched.state && validation.errors.state ? (
                      <FormFeedback type="invalid">
                        {validation.errors.state}
                      </FormFeedback>
                    ) : null}
                  </Col>
                  <Col xl={12}>
                    <Label className="col-form-label">
                      PIN Code
                      <span className="error">*</span>
                    </Label>
                    <Input
                      name="pin_code"
                      type="text"
                      className="form-control"
                      id="horizontal-firstname-Input"
                      placeholder="Enter Pin Code"
                      value={validation.values.pin_code}
                      onChange={validation.handleChange}
                      invalid={
                        validation.touched.pin_code &&
                        validation.errors.pin_code
                      }
                    />
                    {validation.touched.pin_code &&
                    validation.errors.pin_code ? (
                      <FormFeedback type="invalid">
                        {validation.errors.pin_code}
                      </FormFeedback>
                    ) : null}
                  </Col>
                </>
              )}

              <Col xl={12}>
                <Label className="col-form-label">
                  Is Communication Address same as Registered Address?
                  <span className="error">*</span>
                </Label>
                <div className="d-flex flex-row gap-2 cp">
                  <Input
                    className="cp"
                    name="is_comm_address_same"
                    type="radio"
                    value={"SAME"}
                    checked={validation.values.is_comm_address_same === "SAME"}
                    onChange={validation.handleChange}
                    id="comm_address_same"
                  />
                  <Label for="comm_address_same">Yes</Label>
                </div>
                <div className="d-flex flex-row gap-2 cp">
                  <Input
                    className="cp"
                    name="is_comm_address_same"
                    type="radio"
                    value={"DIFFERENT"}
                    checked={
                      validation.values.is_comm_address_same === "DIFFERENT"
                    }
                    onChange={validation.handleChange}
                    id="comm_address_different"
                  />
                  <Label for="comm_address_different">No</Label>
                </div>
              </Col>
              {validation.values.is_comm_address_same === "DIFFERENT" &&
                validation.values.communication_address && (
                  <Col xl={12}>
                    <p
                      className="cp"
                      style={{
                        color: "#09518c",
                        textAlign: "right",
                        fontSize: "13px",
                      }}
                      onClick={() => setOpenAddress(true)}
                    >
                      Edit
                    </p>
                    <textarea
                      type="text"
                      rows={"3"}
                      disabled
                      className="form-control"
                      value={renderAddressValue(
                        validation.values.communication_address
                      )}
                    />
                  </Col>
                )}
              <Col sm={12}>
                <div className="d-flex align-items-center mt-4">
                  <button className="btn btn-primary w-100" type="submit">
                    {isLoading ? <Spinners /> : "Save & Next"}
                  </button>
                </div>
              </Col>
            </Row>
          </Form>

          {validation.values.is_comm_address_same === "DIFFERENT" && (
            <CummunicationAddress
              openAddress={openAddress}
              setOpenAddress={(val, data) => {
                if (
                  !val &&
                  (!data ||
                    (typeof data === "object" &&
                      Object.keys(data).length === 0))
                ) {
                  validation.setFieldValue("is_comm_address_same", "SAME")
                }
                setOpenAddress(val)
              }}
              data={validation.values.communication_address}
              setData={(data) =>
                validation.setFieldValue("communication_address", data)
              }
            />
          )}
        </div>
      </div>
    </>
  )
}

export default CompanyDetails
